export default __webpack_public_path__ + "0330f49e12d33206d6796091080cdf4b.png";